import Swiper, { Navigation} from 'swiper';
Swiper.use([Navigation]);

function FeatureRotator() {
  $('.js-feature-rotator').each(function(index) {
    let $this = $(this);
    $this.addClass('feature-rotator-' + index);
    let fRotatorList = [];

		let fRotator = new Swiper('.feature-rotator-' + index, {
			speed: 400,
			spaceBetween: 20,
			centeredSlides: true,
			loop: false,
		  	simulateTouch: true,
			slidesPerView: 1,
		  	breakpoints: {
						767: {
				  slidesPerView: 1.5,
				  spaceBetween: 60,
						},
						991: {
				  slidesPerView: 2,
				  spaceBetween: 80
						},
						1199: {
				  slidesPerView: 2.35,
				  spaceBetween: 130
				},
				1400: {
				  slidesPerView: 2.35,
				  spaceBetween: 165
						}
			  },

      navigation:  {
        nextEl: ".feature-rotator .swiper-button-next",
				prevEl: ".feature-rotator .swiper-button-prev"
      }
    });

    fRotatorList.push(fRotator);
    fRotator.init();
	});
}

export function init() {
	FeatureRotator();
}
